import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IndexRoutingModule } from './index-routing.module';
import { MainIndexComponent } from './main-index/main-index.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LayoutModule } from '../layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NguCarouselModule } from '@ngu/carousel';

@NgModule({
  declarations: [MainIndexComponent],
  imports: [
    CommonModule,
    IndexRoutingModule, 
    NgbModule, 
    LayoutModule, 
    TranslateModule, 
    NguCarouselModule,
    FormsModule]
})
export class IndexModule { }
